export default class FormManager {
    constructor() {
        document.querySelector(".c-form") && this.init()
    }

    init() {
        this.setLabelsState();
        this.inputFiles();
    }

    setLabelsState() {
        const data = document.querySelectorAll(".c-form__input")

        data.forEach(el => {
            const label = el.querySelector("label")
            const input = el.querySelector("input, textarea")

            if (input !== null) {
                input.addEventListener("focus", function (e) {
                    e.preventDefault()
                    label.setAttribute("data-input-focus", true)
                    input.setAttribute("data-input-focus", true)
                }, false)

                input.addEventListener("focusout", (e) => {
                    e.preventDefault()
                    if (input.value.length === 0) {
                        label.setAttribute("data-input-focus", false)
                        input.setAttribute("data-input-focus", false)
                    }
                }, false)
            }
        })
    }

    inputFiles() {
        const inputFiles = document.querySelectorAll('.c-form__inputfile')

        inputFiles.forEach(input => input.addEventListener('change', function () { processSelectedFiles(this) }))

        function processSelectedFiles(container) {
            const input = container.querySelector('input')
            const filename = input.files[0].name
            const label = container.querySelector('label')

            label.innerText = filename;

            container.classList.add('c-form__inputfile--active');
        }

    }

}
